import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Admin from '../auth/Admin';
import OrganizationSelector from '../userMgmt/OrganizationSelector';
import BuildingMultiSelector from '../buildingselector/BuildingMultiSelector';
import BuildingSelector from '../buildingselector/BuildingSelector';
import DatePicker from './DatePicker';

import './changelog-filter.css';

const ChangelogFilters = ({ filters, setFilters, noun, noDates, singleBuilding }) => (
  <>
    <Admin superAdmin>
      <div className="changelog-filter">
        <Typography variant="h6">Org:</Typography>
        <OrganizationSelector
          allowNulls
          selected={filters.orgId}
          onValueChange={(orgId) => setFilters({ ...filters, orgId, buildings: [] })}
        />
      </div>
    </Admin>
    <div className="changelog-filter">
      <Typography variant="h6">Building Selection:</Typography>
      {singleBuilding ? (
        <BuildingSelector
          selectedBuildingId={filters.buildings[0] ?? -1}
          orgId={filters.orgId}
          handleSelection={(e) => setFilters({ ...filters, buildings: [e.target.value] })}
        />
      ) : (
        <BuildingMultiSelector
          selected={filters.buildings}
          orgId={filters.orgId}
          onValueChange={(buildings) => setFilters({ ...filters, buildings })}
        />
      )}
    </div>
    {noDates ? null : (
      <div className="changelog-filter">
        <Typography variant="h6">Date Selection:</Typography>
        <DatePicker
          value={filters.date}
          onChange={(ts) => setFilters({ ...filters, date: ts })}
          noun={noun}
        />
      </div>
    )}
  </>
);

ChangelogFilters.propTypes = {
  noun: PropTypes.string,
  noDates: PropTypes.bool,
  singleBuilding: PropTypes.bool,
};

ChangelogFilters.defaultProps = {
  noun: 'Changes',
  noDates: false,
  singleBuilding: false,
};

export default ChangelogFilters;
